module.exports = __webpack_public_path__ + "static/media/footer_popup_right_arrow_icon.c4b887ff.svg";